import React from 'react';
import { Link } from 'react-router-dom';
import { useReports } from './ReportsContext';
import './Reports.css';

// Landing page for /reports: a card per available report, grouped by category.
// The same catalog drives the sidebar submenu, so this stays in sync
// automatically as reports are added on the backend.
export default function ReportsHome() {
    const { reports, loading, error } = useReports();

    const groups = [];
    const index = {};
    for (const r of reports) {
        if (!(r.category in index)) {
            index[r.category] = groups.length;
            groups.push({ category: r.category, reports: [] });
        }
        groups[index[r.category]].reports.push(r);
    }

    return (
        <div className="page">
            <h1 className="page__title">Reports</h1>
            <p className="page__subtitle">Database-backed reports. Pick one below or from the sidebar.</p>

            {loading && <p className="page__subtitle">Loading reports…</p>}
            {error && <p className="report__error">{error}</p>}
            {!loading && !error && reports.length === 0 && (
                <p className="page__subtitle">No reports are configured yet.</p>
            )}

            {groups.map(group => (
                <section key={group.category} className="reports-group">
                    <h2 className="reports-group__title">{group.category}</h2>
                    <div className="reports-cards">
                        {group.reports.map(report => (
                            <Link key={report.key} to={`/reports/${report.key}`} className="report-card">
                                <span className="report-card__label">{report.label}</span>
                                <span className="report-card__desc">{report.description}</span>
                                {report.date_range && <span className="report-card__badge">Date range</span>}
                            </Link>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
}
